





































import {Prop, Watch} from "vue-property-decorator";
import {Stored} from 'vue-stored-prop-decorator';
import {Component, Vue} from '@/shared/component';
import {Timeout, WatchObjectProperties} from '@/shared/decorator';

import storeTache, {TacheFilter} from '@/stores/modules/tache';

import InputDateFilter from '@/components/Input/DateFilter.vue';

@Component({
	components: {
		InputDateFilter,
	}
})
export default class CrudTacheFilter extends Vue {

	@Prop({ type: Boolean, default: false}) reduce!: boolean;

	@Stored(() => storeTache) private page!: number;
	@Stored(() => storeTache) private filters!: TacheFilter;

	@WatchObjectProperties('filters', TacheFilter)
	@Timeout()
	private filtersWatcher(): void {
		this.page = 0;
		storeTache.dispatch('getC', { filters: true });
	}

	public mounted() {
		this.typeWatcher();
	}

	@Watch('type')
	private typeWatcher(): void {
		this.filters.clear();

	}

}
